export const theme = {
  colors: {
    navy: "#0a192f",
    lightNavy: "#112240",
    lightestNavy: "#233554",
    slate: "#8892b0",
    lightSlate: "#a8b2d1",
    lightestSlate: "#ccd6f6",
    white: "#e6f1ff",
    green: "#64ffda",
  },
  fonts: {
    sf: "SF MONO",
    fira: "Fira Code",
    calibre_b: "Calibre B",
    calibre_r: "Calibre R",
  },
  paddings: {
    container: "150px",
    sideGap: "50px",
  },
  margins: {
    pageTop: "30px",
  },
};
